// Флажок «на этом устройстве вошёл репетитор» для шапки сайта (24.10.2026).
// Ставит и стирает сервер вместе с сессией кабинета (partner-cabinet-cookie.server.ts).
// Без секрета: входа не даёт, только меняет кнопки шапки.
export const TUTOR_FLAG_COOKIE = "yt_tutor";

/** Есть ли флажок в document.cookie. На сервере и без cookie — false. */
export function hasTutorFlag(cookie: string | null | undefined): boolean {
  return !!cookie && cookie.split(/;\s*/).some((c) => c === `${TUTOR_FLAG_COOKIE}=1`);
}
